<script>
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import {ref, watch} from "vue";
import Swal from "sweetalert2";
import LoadingPic from "@/components/assetComponents/LoadingPic.vue";
import $ from "jquery";
import {useRoute} from "vue-router";
import router from "@/router";
import NavbarPage from "@/components/assetComponents/NavbarPage.vue";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";


export default {
  name: "NewProfileConsultant",
  components: {NavbarPage, LoadingPic, LoadingPage},

  setup() {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0

    let urlFile = localStorage.getItem('urlFile')
    let action = ref(useRoute().params.action)

    let page_select_place = ref('state')
    let country = ref([])
    let citys = ref([])
    // let streets = ref([])

    let sliderValue = ref()

    let place = ref({
      city_name: null,
      // street_name: null,
    })

    let loading = ref(false)
    let dialog = ref(false)
    let loading_prof = ref(false)

    let show_profile = ref(null)
    let pics_album = ref([])

    let page = ref('one')

    let category = ref([])
    let sub_category = ref(null)

    let data = ref({
      time_work: {
        start_morning: null,
        end_morning: null,
        start_evining: null,
        end_evening: null
      },
      gallery: [],
      category: null,
      sub_category: null,
      state_id: null,
      city_id: null,
      // street_id: null,
      address: null,
      landline_phone: null,
      phone: null,
      description: null,
      profile_pic: null,
      name: null,
      web_link: null,
      insta_link: null,
      telegram_link: null,
      eita_link: null,
      rubika_link: null,
      work_years: '',
      business_id: null
    })

  async function load_category() {

      loading.value = true
     await FreeWorld.Heisenberg({}, 'executives_category').then(async (result) => {

        loading.value = false
        category.value = result.data

       await get_country()

      }).catch((result) => {
        loading.value = false
        Swals.Catch(result, load_category)
      })

    }

    load_category()

    async function get_country() {
      loading.value = true

     await FreeWorld.Heisenberg({}, 'user/city').then((res) => {

        loading.value = false
        country.value = res.data.results

      }).catch((result) => {
        loading.value = false
        Swals.Catch(result, get_country)
      })
    }

    function edit_profile() {

      loading.value = true
      FreeWorld.Heisenberg({profile_id: action.value, action: 'show'} , 'excutives_edit').then((result) => {

        loading.value = false
        let res = result.data
        data.value = {
          time_work: {
            start_morning: res.time_work.start_morning,
            end_morning: res.time_work.end_morning,
            start_evining: res.time_work.start_evining,
            end_evening: res.time_work.end_evening
          },
          gallery: res.gallery,
          category: res.category,
          sub_category: res.sub_category,
          state_id: res.state_id,
          city_id: res.city_id,
          // street_id: res.street_id,
          address: res.address,
          landline_phone: res.landline_phone,
          phone: res.phone,
          description: res.description,
          profile_pic: res.profile_pic,
          name: res.name,
          web_link: res.web_link,
          insta_link: res.insta_link,
          telegram_link: res.telegram_link,
          eita_link: res.eita_link,
          rubika_link: res.rubika_link,
          work_years: res.work_years,
          business_id: res.business_id,
        }
        show_profile.value = res.profile_pic
        country.value.forEach((item) => {
          if (data.value.state_id == item.id) {
            item.city.forEach((city) => {
              if (data.value.city_id == city.id) {
                place.value.city_name = city.name
                // city.street.forEach((street)=>{
                //   if (data.value.street_id == street.id){
                //     place.value.street_name = street.name
                //   }
                // })
              }
            })
          }
        })

        chang_category()

      }).catch((result) => {

        loading.value = false
        if (result.message == 'Network Error') {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'تلاش مجدد',
            text: 'لطفا فیلتر شکن را خاموش کرده یا وضعیت اینترنت را برسی کنید',
            allowOutsideClick: false,
          }).then((result) => {
            if (result.isConfirmed) {
              edit_profile()
            }
          })
        } else {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'تلاش مجدد',
            text: '!خطای ارتباط با سرور',
            allowOutsideClick: false,
          }).then((result) => {
            if (result.isConfirmed) {
              edit_profile()
            }
          })
        }
      })

    }

    if (action.value !== 'new') {
      edit_profile()
    }

    function chang_category() {

      if (data.value.category != null) {

        category.value.forEach((item) => {

          if (data.value.category == item.id) {

            if (item.sub_cat.length != 0) {

              sub_category.value = item.sub_cat

            } else {
              $("#sub_cat").addClass('animate__animated animate__fadeOutRight')
              setTimeout(() => {
                sub_category.value = null
              }, 600)
            }

          }

        })

      } else {

        $("#sub_cat").addClass('animate__animated animate__fadeOutRight')
        setTimeout(() => {
          sub_category.value = null
        }, 600)
      }

    }

    function change_country(status, id, name) {

      if (status == 'state') {

        country.value.forEach((item) => {
          if (id == item.id) {
            citys.value = item.city
          }
        })
        data.value.state_id = id
        page_select_place.value = 'city'

      } else if (status == 'city') {

        // citys.value.forEach((item) => {
        //   if (id == item.id) {
        //     streets.value = item.street
        //   }
        // })

        data.value.city_id = id
        place.value.city_name = name
        open_select_place()
      }
      // else if (status == 'street') {
      //   place.value.street_name = name
      //   data.value.street_id = id
      //   open_select_place()
      // }

    }

    function open_select_place() {
      if (!dialog.value) {

        dialog.value = true
        $(".select_state").removeClass('animate__fadeOut').addClass('animate__fadeIn')

      } else {

        if (place.value.city_name == null) {
          // place.value.street_name = null
          // data.value.street_id = null
          place.value.city_name = null
          data.value.state_id = null
          data.value.city_id = null
        }

        $(".select_state").addClass('animate__fadeOut').removeClass('animate__fadeIn')
        setTimeout(() => {
          dialog.value = false
          page_select_place.value = 'state'
        }, 600)

      }
    }

    function remove_pic(action, name) {

      if (action == 'profile') {

        show_profile.value = null
        data.value.profile_pic = null

      } else if (action == 'album') {

        data.value.gallery.forEach((item, index) => {

          if (item.gallery_name == name) {

            data.value.gallery.splice(index, 1)

          }

        })

      }

    }

    function update_profile(e) {

      const file = e.target.files[0];
      if (file != undefined) {
        loading_prof.value = true

        FreeWorld.Goodman(file).then(function (response) {

          show_profile.value = URL.createObjectURL(file);
          loading_prof.value = false
          var res = response.data
          data.value.profile_pic = res.url

        }).catch((result) => {

          loading_prof.value = false
          if (result.message == 'Network Error') {
            Swal.fire({
              icon: 'error',
              confirmButtonText: 'تلاش مجدد',
              text: 'لطفا فیلتر شکن را خاموش کرده یا وضعیت اینترنت را برسی کنید',
            }).then((result) => {
              if (result.isConfirmed) {
                update_profile(e)
              }
            })
          } else {
            Swal.fire({
              icon: 'error',
              confirmButtonText: 'تلاش مجدد',
              text: '!خطای ارتباط با سرور',
            }).then((result) => {
              if (result.isConfirmed) {
                update_profile(e)
              }
            })
          }
        })
      }


    }

    function crated_profile() {

      if (data.value.web_link != null && data.value.web_link.trim().length === 0) data.value.web_link = null
      if (data.value.insta_link != null && data.value.insta_link.trim().length === 0) data.value.insta_link = null
      if (data.value.telegram_link != null && data.value.telegram_link.trim().length === 0) data.value.telegram_link = null
      if (data.value.eita_link != null && data.value.eita_link.trim().length === 0) data.value.eita_link = null
      if (data.value.rubika_link != null && data.value.rubika_link.trim().length === 0) data.value.rubika_link = null
      if (data.value.business_id != null && data.value.business_id.length === 0) data.value.business_id = null


      if (data.value.phone != null && data.value.phone.length == 0) data.value.phone = null
      if (data.value.landline_phone != null && data.value.landline_phone.length == 0) data.value.landline_phone = null

      if (data.value.name != null && data.value.name.trim().length == 0 || data.value.name == null) {

        Swal.fire({
          text: "لطفا عنوان پروفایل خود را وارد کنید!",
          icon: "warning",
          showCancelButton: false,
          confirmButtonText: "متوجه شدم",
          showClass: {
            popup: 'animate__animated animate__bounceInDown'
          },
          hideClass: {
            popup: 'animate__animated animate__bounceOutUp'
          }
        }).then((result) => {
          if (result.isConfirmed) {
            page.value = 'one'
          }
        });

      } else if (data.value.description != null && data.value.description.trim().length == 0 || data.value.description == null) {

        Swal.fire({
          text: "لطفا توضیحات خود را وارد کنید!",
          icon: "warning",
          showCancelButton: false,
          confirmButtonText: "متوجه شدم",
          showClass: {
            popup: 'animate__animated animate__bounceInDown'
          },
          hideClass: {
            popup: 'animate__animated animate__bounceOutUp'
          }
        }).then((result) => {
          if (result.isConfirmed) {
            page.value = 'one'
          }
        });

      } else if (data.value.phone == null && data.value.landline_phone == null) {

        Swal.fire({
          text: "لطفا حداقل یک شماره تلفن وارد کنید!",
          icon: "warning",
          showCancelButton: false,
          confirmButtonText: "متوجه شدم",
          showClass: {
            popup: 'animate__animated animate__bounceInDown'
          },
          hideClass: {
            popup: 'animate__animated animate__bounceOutUp'
          }
        }).then((result) => {
          if (result.isConfirmed) {
            page.value = 'one'
          }
        });

      } else if (data.value.address != null && data.value.address.length == 0 || data.value.address == null) {

        Swal.fire({
          text: "لطفا آدرس خود را وارد کنید!",
          icon: "warning",
          showCancelButton: false,
          confirmButtonText: "متوجه شدم",
          showClass: {
            popup: 'animate__animated animate__bounceInDown'
          },
          hideClass: {
            popup: 'animate__animated animate__bounceOutUp'
          }
        }).then((result) => {
          if (result.isConfirmed) {
            page.value = 'one'
          }
        });

      } else if (data.value.category == null) {

        Swal.fire({
          text: "لطفا دسته بندی پروفایل خود را مشخص کنید!",
          icon: "warning",
          showCancelButton: false,
          confirmButtonText: "متوجه شدم",
          showClass: {
            popup: 'animate__animated animate__bounceInDown'
          },
          hideClass: {
            popup: 'animate__animated animate__bounceOutUp'
          }
        }).then((result) => {
          if (result.isConfirmed) {
            page.value = 'two'
          }
        });

      } else if (sub_category.value != null && data.value.sub_category == null) {

        Swal.fire({
          text: "لطفا زیر دسته آگهی خود را مشخص کنید!",
          icon: "warning",
          showCancelButton: false,
          confirmButtonText: "متوجه شدم",
          showClass: {
            popup: 'animate__animated animate__bounceInDown'
          },
          hideClass: {
            popup: 'animate__animated animate__bounceOutUp'
          }
        }).then((result) => {
          if (result.isConfirmed) {
            page.value = 'two'
          }
        });

      } else if (data.value.state_id == null || data.value.city_id == null) {

        Swal.fire({
          text: "لطفا محدوده پروفایل خود را مشخص کنید!",
          icon: "warning",
          showCancelButton: false,
          confirmButtonText: "متوجه شدم",
          showClass: {
            popup: 'animate__animated animate__bounceInDown'
          },
          hideClass: {
            popup: 'animate__animated animate__bounceOutUp'
          }
        }).then((result) => {
          if (result.isConfirmed) {
            page.value = 'two'
          }
        });

      } else if (data.value.time_work.end_morning != null && data.value.time_work.end_morning.length == 0 ||
          data.value.time_work.end_evening != null && data.value.time_work.end_evening.length == 0 ||
          data.value.time_work.start_morning != null && data.value.time_work.start_morning.length == 0 ||
          data.value.time_work.start_evining != null && data.value.time_work.start_evining.length == 0 ||
          data.value.time_work.start_evining == null || data.value.time_work.start_morning == null ||
          data.value.time_work.end_evening == null || data.value.time_work.end_morning == null
      ) {

        Swal.fire({
          text: "لطفا ساعات کاری خود را وارد کنید!",
          icon: "warning",
          showCancelButton: false,
          confirmButtonText: "متوجه شدم",
          showClass: {
            popup: 'animate__animated animate__bounceInDown'
          },
          hideClass: {
            popup: 'animate__animated animate__bounceOutUp'
          }
        }).then((result) => {
          if (result.isConfirmed) {
            page.value = 'two'
          }
        });

      } else if (data.value.work_years.trim().length === 0) {

        Swal.fire({
          text: "لطفا سابقه کاری خود را به صورت صحیح وارد کنید!",
          icon: "warning",
          showCancelButton: false,
          confirmButtonText: "متوجه شدم",
          showClass: {
            popup: 'animate__animated animate__bounceInDown'
          },
          hideClass: {
            popup: 'animate__animated animate__bounceOutUp'
          }
        }).then((result) => {
          if (result.isConfirmed) {
            page.value = 'two'
          }
        });

      }else if (data.value.business_id && data.value.business_id.length !== 10) {

        Swal.fire({
          text: "لطفا شناسه صنفی را به صورت صحیح وارد کنید!",
          icon: "warning",
          showCancelButton: false,
          confirmButtonText: "متوجه شدم",
          showClass: {
            popup: 'animate__animated animate__bounceInDown'
          },
          hideClass: {
            popup: 'animate__animated animate__bounceOutUp'
          }
        }).then((result) => {
          if (result.isConfirmed) {
            page.value = 'two'
          }
        });

      } else if (data.value.web_link != null && !data.value.web_link.toLowerCase().startsWith('https://')) {

        Swal.fire({
          text: "لطفا لینک وبسایت خود را به صورت صحیح وارد کنید!",
          icon: "warning",
          showCancelButton: false,
          confirmButtonText: "متوجه شدم",
          showClass: {
            popup: 'animate__animated animate__bounceInDown'
          },
          hideClass: {
            popup: 'animate__animated animate__bounceOutUp'
          }
        }).then((result) => {
          if (result.isConfirmed) {
            page.value = 'two'
          }
        });

      }else if(data.value.insta_link !== null && !data.value.insta_link?.toLowerCase().startsWith('@')){

        Swal.fire({
          text: "لطفاآیدی اینستاگرام خود را به صورت صحیح وارد کنید!",
          icon: "warning",
          showCancelButton: false,
          confirmButtonText: "متوجه شدم",
          showClass: {
            popup: 'animate__animated animate__bounceInDown'
          },
          hideClass: {
            popup: 'animate__animated animate__bounceOutUp'
          }
        }).then((result) => {
          if (result.isConfirmed) {
            page.value = 'two'
          }
        });

      } else {

        let url = 'executives'

        if (action.value !== 'new') {
          data.value.profile_id = action.value
          data.value.action = 'edite'
          url = 'excutives_edit'
        }

        loading.value = true
        FreeWorld.Heisenberg(data.value , url , true).then((result) => {

          loading.value = false
          let res = result.data

          let message = {
            ok: "پروفایل شما با موفقیت ثبت شد",
            error: "متاسفانه پروفایل شما ثبت نشد"
          }

          if (data.value.action) {
            message.ok = "پروفایل شما با موفقیت ویرایش شد",
                message.error = "متاسفانه پروفایل شما ویرایش نشد"
          }
          if (res.status == 'ok') {

            Swal.fire({
              position: "center",
              icon: "success",
              title: message.ok,
              showConfirmButton: true,
              confirmButtonText: 'متوجه شدم',
              allowOutsideClick: false,
              showClass: {
                popup: 'animate__animated animate__bounceInDown'
              },
              hideClass: {
                popup: 'animate__animated animate__bounceOutUp'
              }
            }).then((result) => {

              if (result.isConfirmed)
                router.push({name: 'ProfileExecutives'})
            })

          } else {

            Swal.fire({
              position: "center",
              icon: "error",
              title: message.error,
              showConfirmButton: true,
              confirmButtonText: 'متوجه شدم',
              allowOutsideClick: false,
              showClass: {
                popup: 'animate__animated animate__bounceInDown'
              },
              hideClass: {
                popup: 'animate__animated animate__bounceOutUp'
              }
            }).then((result) => {

              if (result.isConfirmed)
                router.push({name: 'HomePage'})
            })

          }

        }).catch((result) => {

          loading.value = false
          if (result.message == 'Network Error') {
            Swal.fire({
              icon: 'error',
              confirmButtonText: 'تلاش مجدد',
              text: 'لطفا فیلتر شکن را خاموش کرده یا وضعیت اینترنت را برسی کنید',
            }).then((result) => {
              if (result.isConfirmed) {
                crated_profile()
              }
            })
          } else {
            Swal.fire({
              icon: 'error',
              confirmButtonText: 'تلاش مجدد',
              text: '!خطای ارتباط با سرور',
            }).then((result) => {
              if (result.isConfirmed) {
                crated_profile()
              }
            })
          }
        })
      }
    }

    function albums(action, name) {

      if (action == 'new') {

        Swal.fire({
          title: 'ساخت آلبوم جدید',
          confirmButtonText: 'ثبت',
          confirmButtonColor: '#FF9900',
          customClass: '',
          html: `
                  <div class="d-flex flex-column">
                  <p class="w-100 text-end">
عنوان آلبوم
                   </p>
                  <input id="swal-input1" class="form-control" type="text">
                  </div>
  `,
        }).then((result) => {
          if (result.isConfirmed) {
            let album_name = document.getElementById('swal-input1').value

            if (album_name.trim().length == 0) {

              Swal.fire({
                text: "لطفا نام آلبوم را وارد کنید!",
                icon: "warning",
                showCancelButton: false,
                confirmButtonText: "متوجه شدم",
                showClass: {
                  popup: 'animate__animated animate__bounceInDown'
                },
                hideClass: {
                  popup: 'animate__animated animate__bounceOutUp'
                }
              })

            } else if (data.value.gallery.length == 0) {
              data.value.gallery.push({
                gallery_name: album_name,
                pic_link: [],
              })
            } else {

              var repeat = false
              data.value.gallery.forEach((item) => {

                if (album_name == item.gallery_name) {

                  Swal.fire({
                    text: "این عنوان را قبلا استفاده کرده اید!",
                    icon: "warning",
                    showCancelButton: false,
                    confirmButtonText: "متوجه شدم",
                    showClass: {
                      popup: 'animate__animated animate__bounceInDown'
                    },
                    hideClass: {
                      popup: 'animate__animated animate__bounceOutUp'
                    }
                  })

                } else {
                  repeat = true
                }

              })
              if (repeat == true) {
                data.value.gallery.push({
                  gallery_name: album_name,
                  pic_link: [],
                })
                repeat = false
              }
            }
          }
        })
      }

      if (action == 'add') {

        var file = document.getElementById('album' + name).files[0]
        let loading_album = document.getElementById('loading' + name)

        data.value.gallery.forEach((item) => {

          if (item.gallery_name == name) {
            loading_album.style.display = 'block'
            FreeWorld.Goodman(file).then(function (response) {

              loading_album.style.display = 'none'
              var res = response.data
              item.pic_link.push(res.url)

            }).catch((result) => {

              loading_album.style.display = 'none'
              if (result.message == 'Network Error') {
                Swal.fire({
                  icon: 'error',
                  confirmButtonText: 'تلاش مجدد',
                  text: 'لطفا فیلتر شکن را خاموش کرده یا وضعیت اینترنت را برسی کنید',
                }).then((result) => {
                  if (result.isConfirmed) {
                    albums(action, name)
                  }
                })
              } else {
                Swal.fire({
                  icon: 'error',
                  confirmButtonText: 'تلاش مجدد',
                  text: '!خطای ارتباط با سرور',
                }).then((result) => {
                  if (result.isConfirmed) {
                    albums(action, name)
                  }
                })
              }
            })

          }

        })

      }

      if (action == 'update') {

        var pic = document.getElementById('new_pic_album' + name).files[0]
        let loading_album = document.getElementById('loading' + name)


        data.value.gallery.forEach((item) => {

          if (item.gallery_name == name) {

            loading_album.style.display = 'block'
            FreeWorld.Goodman(pic).then(function (response) {

              loading_album.style.display = 'none'
              var res = response.data
              item.pic_link.push(res.url)

            }).catch((result) => {

              loading_album.style.display = 'none'
              if (result.message == 'Network Error') {
                Swal.fire({
                  icon: 'error',
                  confirmButtonText: 'تلاش مجدد',
                  text: 'لطفا فیلتر شکن را خاموش کرده یا وضعیت اینترنت را برسی کنید',
                }).then((result) => {
                  if (result.isConfirmed) {
                    albums(action, name)
                  }
                })
              } else {
                Swal.fire({
                  icon: 'error',
                  confirmButtonText: 'تلاش مجدد',
                  text: '!خطای ارتباط با سرور',
                }).then((result) => {
                  if (result.isConfirmed) {
                    albums(action, name)
                  }
                })
              }
            })

          }

        })

      }

    }

    watch(()=>page.value , ()=>{
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    })

    return {

      loading,
      loading_prof,
      change_country,
      open_select_place,
      page_select_place,
      country,
      citys,
      // streets,
      place,
      page,
      data,
      update_profile,
      show_profile,
      remove_pic,
      crated_profile,
      albums,
      urlFile,
      pics_album,
      sliderValue,
      category,
      chang_category,
      sub_category,
      dialog,

    }
  }
}
</script>

<template>

  <LoadingPage v-if="loading"></LoadingPage>
  <div @click="open_select_place" v-show="dialog" id="alert_background_place" class="alert_background"></div>
  <div v-show="dialog" id="select_state" class="select_state px-5 mt-3 max_width animate__animated animate__fadeIn">
    <div class="bg-white rounded-4 border-costom">
      <div class="bg-color-liner position-relative rounded-top-4 d-flex justify-content-center align-items-center">
        <img @click="open_select_place" class="icon_closing_filter position-absolute" style="width: 15px"
             src="../assets/img/closing.svg" alt="">
        <img class="py-4" style="width: 100px" src="../assets/img/location_white.svg" alt="">
      </div>

      <div v-if="page_select_place === 'state' " class="px-2 py-3 overflow-y-scroll" style="height: 400px">

        <div v-for="item in country" :key="item.id" @click="change_country('state', item.id)" class="d-flex justify-content-between py-3">
          <p class="m-0">{{ item.name }}</p>

          <img class="m-0 mx-2" style="width: 8px" src="../assets/img/down-arrow.svg" alt="">
        </div>

      </div>

      <div v-if="page_select_place === 'city' " class="px-2 py-3 overflow-y-scroll" style="height: 400px">

        <div v-for="item in citys" :key="item.id" @click="change_country('city', item.id , item.name)" class="d-flex justify-content-between py-3">
          <p class="m-0">{{ item.name }}</p>

          <img class="m-0 mx-2" style="width: 8px" src="../assets/img/down-arrow.svg" alt="">
        </div>

      </div>

      <!--        <div v-if="page_select_place == 'street' " class="px-2 py-3 overflow-y-scroll" style="height: 400px">-->

      <!--&lt;!&ndash;          <div @click="change_country('all_street')" class="d-flex justify-content-between py-3">&ndash;&gt;-->
      <!--&lt;!&ndash;            <img class="m-0 mx-2" style="width: 8px" src="../assets/img/down-arrow.svg" alt="">&ndash;&gt;-->
      <!--&lt;!&ndash;            <p class="m-0 font-5">همه خیابان ها</p>&ndash;&gt;-->
      <!--&lt;!&ndash;          </div>&ndash;&gt;-->

      <!--          <div v-for="item in streets" :key="item.id" @click="change_country('street', item.id , item.name)"-->
      <!--               class="d-flex justify-content-between py-3">-->
      <!--            <img class="m-0 mx-2" style="width: 8px" src="../assets/img/down-arrow.svg" alt="">-->
      <!--            <p class="m-0 font-5">{{ item.name }}</p>-->
      <!--          </div>-->

      <!--        </div>-->

    </div>

  </div>


  <div id="main" :class="loading ? 'activeClass' : '' " class="bg-main">
    <div dir="ltr" v-if="page === 'one' " class="bg-main">
      <div class="div-top-arrow bg-color d-flex align-items-center justify-content-between">
        <div onclick="history.back()" class="d-flex align-items-center">
          <p class="m-0">
            انصراف
          </p>
          <img class="svg-arrow" src="../assets/img/closing.svg" alt="">
        </div>
        <div class="d-flex align-items-center">
          <p class="m-0">
            ساخت پروفایل
          </p>

          <div onclick="history.back()">
            <img class="svg-arrow" src="../assets/img/back.svg" alt="">
          </div>

        </div>
      </div>
      <br>
      <br>
      <br>
      <div class="p-body mt-2 animate__animated animate__fadeIn">
        <div class="w-100">
          <p class="font-4 mb-2 font-bold text-end">
            عکس پروفایل
          </p>
          <p class="font-5 text-end">
            افزودن عکس بازدید پروفایل شما را افزایش می دهد
          </p>
          <div dir="rtl" class="">


            <div class="add_prolile rounded-4 ml-1 position-relative">
              <img @click="remove_pic('profile')" v-if="show_profile != null " style="width: 25px; right: 3px; top: 3px"
                   class="position-absolute z-1" src="../assets/img/closing_color.svg" alt="">
              <label :class="loading_prof ? 'pe-none' : '' " for="profile"
                     style="position: relative; width:100%;height:100%;overflow:hidden;padding:0;cursor:pointer">

                <LoadingPic v-if="loading_prof"></LoadingPic>

                <img v-if="show_profile == null" id="slider_client_add_2" src="../assets/img/add_picture.svg"
                     style="width:100%;height:100%;border-radius: 10px;">

                <img v-else id="slider_client_add_2" :src="show_profile"
                     style="width:100%;height:100%;border-radius: 10px;">

              </label>
              <input @change="update_profile" type="file" name="file" id="profile" style="display: none">
            </div>

          </div>
        </div>
        <hr>
        <div class="w-100">
          <p class="font-4 font-bold text-end">
            عنوان پروفایل
          </p>
          <p class="font-5 text-end">
            نام شخص یا گروه
          </p>
          <input class="p-2 bg-white w-100 input_dir border-costom rounded-3" type="text" v-model="data.name"
                 maxlength="50">
        </div>
        <hr>
        <div class="w-100">
          <p class="font-4 font-bold text-end">
            توضیحات و افتخارات
          </p>
          <p class="font-5 text-end">
            جزئیات و نکات قابل توجه خود را کامل و دقیق بنویسید
          </p>
          <textarea v-model="data.description"
                    class="textarea_users bg-white input_dir w-100 border-costom p-2 rounded-4"
                    maxlength="300"></textarea>
        </div>
        <hr>
        <div class="w-100">
          <p class="font-4 font-bold text-end">
            شماره تلفن
          </p>
          <p class="font-5 text-end">
            شماره تلفن درج در پروفایل
          </p>
          <input v-model="data.phone" class="p-2 w-100 text-center font-4 border-costom rounded-3 mb-2 bg-white"
                 maxlength="11" type="tel" placeholder="شماره تلفن همراه" onkeydown="return event.key != ' '">
          <input v-model="data.landline_phone" class="p-2 w-100 font-4 text-center border-costom bg-white rounded-3"
                 maxlength="11" placeholder="شماره تلفن ثابت" type="tel" onkeydown="return event.key != ' '">
        </div>
        <hr>
        <div class="w-100">
          <p class="font-4 font-bold text-end">
            آدرس محل کار
          </p>
          <p class="font-5 text-end">
            این آدرس در پروفایل نمایش داده میشود
          </p>
          <textarea v-model="data.address" class="textarea_users bg-white input_dir w-100 border-costom p-2 rounded-4"
                    maxlength="300"></textarea>
        </div>
      </div>

      <div class="button_div w-100 p-body d-flex justify-content-start bg-main ">
        <v-btn @click="page = 'two' " class="w-45 h-75 bg-color rounded-2 border-costom text-white my-2 ">
          بعدی
        </v-btn>
      </div>
    </div>

    <div dir="ltr" v-if="page === 'two' " class="bg-main">

      <div class="div-top-arrow bg-color d-flex z-3 align-items-center justify-content-between">
        <div onclick="history.back()" class="d-flex align-items-center">
          <p class="m-0">
            انصراف
          </p>
          <img class="svg-arrow" src="../assets/img/closing.svg" alt="">
        </div>
        <div class="d-flex align-items-center">
          <p class="m-0">
            ساخت پروفایل
          </p>
          <div @click="page = 'one' ">
            <img class="svg-arrow" src="../assets/img/back.svg" alt="">
          </div>
        </div>
      </div>
      <br>
      <br>
      <br>

      <div class="p-body mt-2 animate__animated animate__fadeIn">

        <div class="bg-white rounded-4 p-3">

          <div class="d-flex py-2 justify-content-between align-items-center">
            <div class="d-flex align-items-center">
              <img style="width: 8px" src="../assets/img/down-arrow.svg" alt="">
              <select @change="chang_category" v-model="data.category" class="m-0 mx-2 font-5">
                <option :value="null">انتخاب</option>
                <option v-for="item in category" :key="item.id" :value="item.id">{{ item.name }}</option>
              </select>
            </div>
            <p class="m-0 font-4">
              دسته بندی فعالیت
            </p>
          </div>


          <div v-if="sub_category != null " id="sub_cat" class="animate__animated animate__fadeIn">
            <hr>

            <div class="d-flex py-2 justify-content-between align-items-center">
              <div class="d-flex align-items-center">
                <img style="width: 8px" src="../assets/img/down-arrow.svg" alt="">
                <select v-model="data.sub_category" class="m-0 mx-2 font-5">
                  <option :value="null">انتخاب</option>
                  <option v-for="item in sub_category" :key="item.id" :value="item.id">{{ item.name }}</option>
                </select>
              </div>
              <p class="m-0 font-4">
                زیر دسته فعالیت
              </p>
            </div>

          </div>


          <hr>

          <div class="d-flex py-2 justify-content-between align-items-center">
            <div class="d-flex align-items-center">
              <img style="width: 8px" src="../assets/img/down-arrow.svg" alt="">

              <div @click="open_select_place" v-if="place.city_name != null " class="d-flex ml-2">

                <!--              <p class="m-0 font-5 d-flex align-items-center ">{{ place.street_name }}</p>-->

                <!--              <span class="mx-1">-</span>-->

                <p class="m-0 font-5 d-flex align-items-center">{{ place.city_name }}</p>

              </div>
              <p v-else @click="open_select_place" class="m-0 mx-2 font-5">
                انتخاب
              </p>
            </div>
            <p class="m-0 font-4">
              محدوده آگهی
            </p>
          </div>

        </div>

        <br>

        <div class="bg-white rounded-4 p-3">
          <p class="font-4 text-end">
            انتخاب ساعت کاری
          </p>
          <div class="d-flex justify-content-between">
            <div class="w-45">
              <p class="font-5 text-end">
                عصر تا شب
              </p>
              <div class="d-flex justify-content-between">
                <input class="border-costom bg-main w-45 py-2 rounded-2 text-center" placeholder="تا"
                       type="number" v-model="data.time_work.end_evening" onkeydown="return event.key != ' '">
                <input class="border-costom bg-main w-45 py-2 rounded-2 text-center" placeholder="از"
                       type="number" v-model="data.time_work.start_evining" onkeydown="return event.key != ' '">
              </div>
            </div>
            <div class="w-45">
              <p class="font-5 text-end">
                صبح تا ظهر
              </p>
              <div class="d-flex justify-content-between">
                <input class="border-costom bg-main w-45 py-2 rounded-2 text-center" placeholder="تا"
                       type="number" v-model="data.time_work.end_morning" onkeydown="return event.key != ' '">
                <input class="border-costom bg-main w-45 py-2 rounded-2 text-center" placeholder="از"
                       type="number" v-model="data.time_work.start_morning" onkeydown="return event.key != ' '">
              </div>
            </div>
          </div>
        </div>

        <br>

        <div class="mb-2">
          <p class="font-4 font-bold text-end p-body mb-1">
            سابقه کاری
          </p>
          <input class="w-100 border-costom p-3 bg-white rounded-4 font-5 text-center" type="text"
                 v-model="data.work_years">
        </div>

        <div class="mb-2">
          <p class="font-4 font-bold text-end p-body mb-1">
            شناسه صنفی
          </p>
          <input class="w-100 border-costom p-3 bg-white rounded-4 font-5 text-center" type="tel" maxlength="10" onkeydown="return event.key !== ' '"
                 v-model="data.business_id">
        </div>

        <br>

        <div class="w-100">

          <div class="d-flex justify-content-end">
            <p @click="albums('new')" class="bg-color m-0 text-white px-2 py-1 rounded-pill font-6">
              ساخت آلبوم جدید
            </p>

            <p class="font-4 font-bold text-end mb-1 p-body">
              آلبوم تصاویر
            </p>
          </div>

          <p class="font-5 text-end p-body">
            افزودن عکس بازدید پروفایل شما را افزایش می دهد
          </p>

        </div>

        <div v-if="data.gallery.length != 0 " class="list_photos bg-white py-4 rounded-4 mb-4">

          <div v-for="item in data.gallery" :key="item.gallery_name"
               class="selected_photo align-items-center mx-2 position-relative">

            <div v-if="item.pic_link.length == 0" class="add_prolile rounded-4 ml-1 position-relative">

              <label :for="'album' + item.gallery_name"
                     style="position: relative; width:100%;height:100%;overflow:hidden;padding:0;cursor:pointer">

                <img id="slider_client_add_2" src="../assets/img/add_album.svg"
                     style="width:100%;height:100%;border-radius: 10px;">
              </label>
              <input @change="albums('add' , item.gallery_name)" type="file" name="file"
                     :id="'album' + item.gallery_name"
                     style="display: none">
            </div>

            <!--          <img v-if="item.pic_link.length == 0" class="img_selected_user mb-2" src="../assets/img/add_album.svg" alt="">-->

            <img v-else class="img_selected_user mb-2" :src="urlFile + item.pic_link[0]" alt="">
            <img v-if="item.pic_link[1]" class="img_selected_userr mb-2" :src="urlFile + item.pic_link[1]" alt="">

            <LoadingPic style="display: none" :id="'loading' + item.gallery_name "></LoadingPic>

            <p class="m-0 font-6 text-center rounded-pill bg-main py-1 px-2">{{ item.gallery_name }}</p>

            <div v-if="item.pic_link.length != 0" class="position-absolute z-2 top-0 d-flex" style="left: 0">
              <img @click="remove_pic('album' , item.gallery_name)" class="icon_album"
                   src="../assets/img/delete_albom.svg">
              <label :for="'new_pic_album' + item.gallery_name">
                <img class="icon_album" src="../assets/img/add_albom.svg">
              </label>
              <input @change="albums('update' , item.gallery_name)" type="file" name="file"
                     :id="'new_pic_album' + item.gallery_name" style="display: none">
            </div>

          </div>

        </div>


        <div class="mb-2">
          <p class="font-4 font-bold text-end p-body mb-1">
            لینک وبسایت
          </p>
          <p class="font-5 text-end p-body mb-1">
            شروع شود https:// لینک با
          </p>
          <input class="w-100 border-costom p-3 bg-white rounded-4 font-5 text-center" placeholder="میتواند خالی باشد"
                 type="text" v-model="data.web_link">
        </div>

        <div class="mb-2">
          <p class="font-4 font-bold text-end p-body mb-1">
            آیدی پیام رسان اینستاگرام
          </p>

          <p class="font-5 text-end p-body mb-1">
            آیدی با @ شروع شود
          </p>

          <input dir="ltr" class="w-100 border-costom p-3 bg-white rounded-4 font-5 text-center" placeholder="میتواند خالی باشد"
                 type="text" v-model="data.insta_link">
        </div>

        <div class="mb-2">
          <p class="font-4 font-bold text-end p-body mb-1">
            آیدی پیام رسان تلگرام
          </p>
          <input class="w-100 border-costom p-3 bg-white font-5 rounded-4 text-center" placeholder="میتواند خالی باشد"
                 type="text" v-model="data.telegram_link">
        </div>

        <div class="mb-2">
          <p class="font-4 font-bold text-end p-body mb-1">
            آیدی پیام رسان ایتا
          </p>
          <input class="w-100 border-costom p-3 bg-white rounded-4 font-5 text-center" placeholder="میتواند خالی باشد"
                 type="text" v-model="data.eita_link">
        </div>

        <div class="mb-2">
          <p class="font-4 font-bold text-end p-body mb-1">
            آیدی پیام رسان روبیکا
          </p>
          <input class="w-100 border-costom p-3 bg-white rounded-4 font-5 text-center" placeholder="میتواند خالی باشد"
                 type="text" v-model="data.rubika_link">
        </div>

        <br>

        <div class="w-100 my-2 d-flex justify-content-center">
          <v-btn @click="crated_profile" class="p-3 w-75 h-75  bg-color font-4 rounded-4 shadow-costom text-white">
            ثبت پروفایل
          </v-btn>
        </div>

      </div>
    </div>
  </div>

  <div id="web" :class="loading ? 'activeClass' : '' " class="bg-main">

    <NavbarPage></NavbarPage>
    <div style="background-color: white" class="rounded-4 font-bold font-color p-3 mb-4 w-75 ma-auto">ساخت پروفایل</div>

    <div v-if="page === 'one' " class="w-75 bg-white p-4 m-auto rounded-4">

      <div class="p-body mt-2 animate__animated animate__fadeIn">
        <div class="w-100">
          <p class="font-5 mb-2 font-bold text-end">
            عکس پروفایل
          </p>
          <p class="font-5 mb-3 text-end">
            افزودن عکس بازدید پروفایل شما را افزایش می دهد
          </p>

          <div dir="rtl" class="">
            <div class="add_prolile rounded-4 shadow-costom ml-1 position-relative">
              <img @click="remove_pic('profile')" v-if="show_profile != null " style="width: 25px; right: 3px; top: 3px"
                   class="position-absolute z-1" src="../assets/img/closing_color.svg" alt="">
              <label :class="loading_prof ? 'pe-none' : '' " for="profile" class=""
                     style="position: relative; width:100%;height:100%;overflow:hidden;padding:0;cursor:pointer">

                <LoadingPic v-if="loading_prof"></LoadingPic>

                <img v-if="show_profile == null" id="slider_client_add_2" src="../assets/img/add_picture.svg"
                     style="width:100%;height:100%;border-radius: 10px;">

                <img v-else id="slider_client_add_2" :src="show_profile"
                     style="width:100%;height:100%;border-radius: 10px;">

              </label>
              <input @change="update_profile" type="file" name="file" id="profile" style="display: none">
            </div>

          </div>
        </div>

        <hr>

        <div class="w-100">
          <div class="d-flex mb-3 align-items-center">
          <p class="font-5 font-bold text-end">عنوان پروفایل</p>
          <p class="font-5 text-end mx-1">(نام شخص یا گروه)</p>
        </div>

          <input class="p-2 bg-white w-100 input_dir border-costom rounded-3" type="text" v-model="data.name" maxlength="50">
        </div>

        <hr>

        <div class="w-100">
          <p class="font-5 mb-2 font-bold text-end">
            توضیحات و افتخارات
          </p>
          <p class="font-5 mb-3 text-end">
            جزئیات و نکات قابل توجه خود را کامل و دقیق بنویسید
          </p>
          <textarea v-model="data.description"
                    class="textarea_users bg-white input_dir w-100 border-costom p-2 rounded-4"
                    maxlength="300"></textarea>
        </div>

        <hr>

        <div class="w-100">
          <p class="font-5 mb-2 font-bold text-end">
            شماره تلفن
          </p>
          <p class="font-5 mb-3 text-end">
            شماره تلفن درج در پروفایل
          </p>
          <input v-model="data.phone" class="p-2 w-100 text-center font-4 border-costom rounded-3 mb-2 bg-white"
                 maxlength="11" type="tel" placeholder="شماره تلفن همراه" onkeydown="return event.key != ' '">
          <input v-model="data.landline_phone" class="p-2 w-100 font-4 text-center border-costom bg-white rounded-3"
                 maxlength="11" placeholder="شماره تلفن ثابت" type="tel" onkeydown="return event.key != ' '">
        </div>

        <hr>

        <div class="w-100">
          <p class="font-5 mb-2 font-bold text-end">
            آدرس محل کار
          </p>
          <p class="font-5 mb-3 text-end">
            این آدرس در پروفایل نمایش داده میشود
          </p>
          <textarea v-model="data.address" class="textarea_users bg-white input_dir w-100 border-costom p-2 rounded-4"
                    maxlength="300"></textarea>
        </div>
      </div>

      <div style="height: 3rem" class="w-100 d-flex justify-content-center">
        <v-btn @click="page = 'two' " class="w-35 h-100 bg-color rounded-2 border-costom text-white my-2 ">
          بعدی
        </v-btn>
      </div>
    </div>

    <div v-if="page === 'two' " class="w-75 bg-white p-4 m-auto rounded-4">
      
      <div class="mt-2 animate__animated animate__fadeIn">

        <div class="bg-white rounded-4 p-3">

          <div class="d-flex py-2 justify-content-between align-items-center">
            <p class="m-0 font-bold font-5">دسته بندی فعالیت</p>
            <div class="d-flex align-items-center justify-content-between w-30">
              <select @change="chang_category" v-model="data.category" class="m-0 mx-2 w-90 text-center font-5">
                <option :value="null">انتخاب</option>
                <option v-for="item in category" :key="item.id" :value="item.id">{{ item.name }}</option>
              </select>
              <img style="width: 8px" src="../assets/img/down-arrow.svg" alt="">
            </div>
          </div>

          <div v-if="sub_category != null " id="sub_cat" class="animate__animated animate__fadeIn">
            <hr>

            <div class="d-flex py-2 justify-content-between align-items-center">
              <p class="m-0 font-bold font-5">زیر دسته فعالیت</p>

              <div class="d-flex align-items-center justify-content-between w-30">
                <select v-model="data.sub_category" class="m-0 mx-2 w-90 font-5">
                  <option :value="null">انتخاب</option>
                  <option v-for="item in sub_category" :key="item.id" :value="item.id">{{ item.name }}</option>
                </select>
                <img style="width: 8px" src="../assets/img/down-arrow.svg" alt="">
              </div>
            </div>
          </div>

          <hr>

          <div class="d-flex py-2 justify-content-between align-items-center">
            <p class="m-0 font-bold font-5">محدوده آگهی</p>

            <div class="d-flex align-items-center justify-content-between w-30">

              <div @click="open_select_place" v-if="place.city_name != null " class="d-flex font-5 w-90 justify-content-center ml-2">

                <!--              <p class="m-0 font-5 d-flex align-items-center ">{{ place.street_name }}</p>-->

                <!--              <span class="mx-1">-</span>-->

                <p class="m-0 font-5">{{ place.city_name }}</p>

              </div>
              <p v-else @click="open_select_place" class="m-0 mx-2 w-90 text-center font-5">انتخاب</p>

              <img style="width: 8px" src="../assets/img/down-arrow.svg" alt="">
            </div>
          </div>

        </div>

        <br>

        <div class="bg-white rounded-4 p-3">
          <p class="font-5 font-bold text-end">انتخاب ساعت کاری</p>

          <div class="d-flex justify-content-between">
            <div class="w-45">
              <p class="font-4 mb-2 text-end">
                صبح تا ظهر
              </p>
              <div class="d-flex justify-content-between">
                <input class="border-costom bg-main w-45 py-2 rounded-2 text-center" placeholder="از" type="number" v-model="data.time_work.start_morning" onkeydown="return event.key != ' '">
                <input class="border-costom bg-main w-45 py-2 rounded-2 text-center" placeholder="تا" type="number" v-model="data.time_work.end_morning" onkeydown="return event.key != ' '">
              </div>
            </div>

            <div class="w-45">
              <p class="font-4 text-end mb-2">
                عصر تا شب
              </p>
              <div class="d-flex justify-content-between">
                <input class="border-costom bg-main w-45 py-2 rounded-2 text-center" placeholder="از" type="number" v-model="data.time_work.start_evining" onkeydown="return event.key != ' '">
                <input class="border-costom bg-main w-45 py-2 rounded-2 text-center" placeholder="تا" type="number" v-model="data.time_work.end_evening" onkeydown="return event.key != ' '">
              </div>
            </div>
          </div>
        </div>

        <br>

        <div class="mb-2">
          <p class="font-4 font-bold text-end p-body mb-1">
            سابقه کاری
          </p>
          <input v-model="data.work_years" class="w-100 border-costom p-3 bg-white rounded-4 font-5 text-center" type="text">
        </div>

        <br>

        <div class="mb-2">
          <p class="font-4 font-bold text-end p-body mb-1">
            شناسه صنفی
          </p>
          <input class="w-100 border-costom p-3 bg-white rounded-4 font-5 text-center" type="tel" maxlength="10" onkeydown="return event.key !== ' '"
                 v-model="data.business_id">
        </div>

        <br>

        <div class="w-100 mb-4">

          <div class="d-flex align-items-center">
            <p class="font-5 font-bold text-end mb-1 p-body">آلبوم تصاویر</p>

            <p @click="albums('new')" class="bg-color m-0 text-white px-2 py-1 rounded-pill font-6">ساخت آلبوم جدید</p>
          </div>

          <p class="font-5 text-end p-body">
            افزودن عکس بازدید پروفایل شما را افزایش می دهد
          </p>

        </div>

        <div v-if="data.gallery.length != 0 " class="list_photos bg-white py-4 rounded-4 mb-4">

          <div v-for="item in data.gallery" :key="item.gallery_name"
               class="selected_photo align-items-center mx-3 position-relative">

            <div v-if="item.pic_link.length == 0" class="add_prolile rounded-4 ml-1 position-relative">

              <label :for="'album' + item.gallery_name"
                     style="position: relative; width:100%;height:100%;overflow:hidden;padding:0;cursor:pointer">

                <img id="slider_client_add_2" src="../assets/img/add_album.svg"
                     style="width:100%;height:100%;border-radius: 10px;">
              </label>
              <input @change="albums('add' , item.gallery_name)" type="file" name="file"
                     :id="'album' + item.gallery_name"
                     style="display: none">
            </div>

            <!--          <img v-if="item.pic_link.length == 0" class="img_selected_user mb-2" src="../assets/img/add_album.svg" alt="">-->

            <img v-else class="img_selected_user mb-2" :src="urlFile + item.pic_link[0]" alt="">
            <img v-if="item.pic_link[1]" class="img_selected_userr mb-2" :src="urlFile + item.pic_link[1]" alt="">

            <LoadingPic style="display: none" :id="'loading' + item.gallery_name "></LoadingPic>

            <p class="m-0 font-6 text-center rounded-pill bg-main py-1 px-2">{{ item.gallery_name }}</p>

            <div v-if="item.pic_link.length != 0" class="position-absolute z-2 top-0 d-flex" style="left: 0">
              <img @click="remove_pic('album' , item.gallery_name)" class="icon_album"
                   src="../assets/img/delete_albom.svg">
              <label :for="'new_pic_album' + item.gallery_name">
                <img class="icon_album" src="../assets/img/add_albom.svg">
              </label>
              <input @change="albums('update' , item.gallery_name)" type="file" name="file"
                     :id="'new_pic_album' + item.gallery_name" style="display: none">
            </div>

          </div>

        </div>


        <div class="mb-2">
          <p class="font-4 font-bold text-end p-body mb-1">
            لینک وبسایت
          </p>
          <p class="font-5 text-end p-body mb-1">
            لینک باید با پسوند //:https شروع شود
          </p>
          <input class="w-100 border-costom p-3 bg-white rounded-4 font-5 text-center" placeholder="میتواند خالی باشد"
                 type="text" v-model="data.web_link">
        </div>

        <div class="mb-2">
          <p class="font-4 font-bold text-end p-body mb-1">
            آیدی پیام رسان اینستاگرام
          </p>
          <p class="font-5 text-end p-body mb-1">
            آیدی با @ شروع شود
          </p>
          <input dir="ltr" class="w-100 border-costom p-3 bg-white rounded-4 font-5 text-center" placeholder="میتواند خالی باشد"
                 type="text" v-model="data.insta_link">
        </div>

        <div class="mb-2">
          <p class="font-4 font-bold text-end p-body mb-1">
            آیدی پیام رسان تلگرام
          </p>
          <input class="w-100 border-costom p-3 bg-white font-5 rounded-4 text-center" placeholder="میتواند خالی باشد"
                 type="text" v-model="data.telegram_link">
        </div>

        <div class="mb-2">
          <p class="font-4 font-bold text-end p-body mb-1">
            آیدی پیام رسان ایتا
          </p>
          <input class="w-100 border-costom p-3 bg-white rounded-4 font-5 text-center" placeholder="میتواند خالی باشد"
                 type="text" v-model="data.eita_link">
        </div>

        <div class="mb-2">
          <p class="font-4 font-bold text-end p-body mb-1">
            آیدی پیام رسان روبیکا
          </p>
          <input class="w-100 border-costom p-3 bg-white rounded-4 font-5 text-center" placeholder="میتواند خالی باشد"
                 type="text" v-model="data.rubika_link">
        </div>

        <br>

        <div class="w-100 my-2 d-flex justify-content-center">
          <v-btn @click="crated_profile" class="p-3 w-75 h-75  bg-color font-4 rounded-4 shadow-costom text-white">
            ثبت پروفایل
          </v-btn>
        </div>

      </div>
  </div>

  </div>

</template>

<style scoped>

.list_photos {
  display: -webkit-box;
  overflow-x: scroll;
}

.list_photos::-webkit-scrollbar {
  display: none;
}

.add_photo {
  width: 140px;
  height: 155px;
  background-color: white;
  border: 1px dashed darkgray;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-left: 5px;
  margin-right: 5px;
}

.selected_photo {
  width: 140px;
  height: 155px;
  display: flex;
  flex-direction: column;
}

.img_selected_user {
  width: 100%;
  height: 130px;
  border-radius: 15px;
  z-index: 2;
}

.img_selected_userr {
  width: 100%;
  height: 124px;
  border-radius: 15px;
  position: absolute;
  left: 5px;
  z-index: 1;
  transform: rotate(7deg);
}

.icon_album {
  width: 35px;
  height: 35px;
}

#select_state {
  position: fixed;
  width: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 21;
}

.icon_closing_filter {
  top: 15px;
  left: 15px;
}


.alert_background {
  position: fixed;
  top: 0;
  height: 100vh;
  width: 100vw;
  background-color: rgba(79, 78, 78, 0.7);
  z-index: 20;
}


.add_prolile {
  width: 130px;
  height: 135px;
}

.textarea_users {
  height: 150px;
  resize: none;
  text-align: right;
}

.button_div {
  height: 70px;
  max-width: 700px;
}

</style>